// src/hooks/useCountries.js
import { BaseHttpService } from 'cms/core/services';
import { useQuery } from 'react-query';

/**
 * Fetches the list of countries from BaseHttpService.
 * Assumes the returned data is an array of objects with properties: code and name.
 * Countries data is cached for 24 hours since it rarely changes.
 */
function useCountries() {
  return useQuery(
    'countries', 
    () => BaseHttpService.loadCountries(),
    {
      staleTime: 24 * 60 * 60 * 1000, // 24 hours - countries rarely change
      cacheTime: 24 * 60 * 60 * 1000, // Keep in cache for 24 hours
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnMount: false, // Don't refetch on component mount if data exists
      refetchOnReconnect: false, // Don't refetch on reconnect
    }
  );
}

export default useCountries;